class CustomCartDrawer {
constructor() {
  this.isApplyingDiscount = false;
  this.drawer = document.querySelector('#CustomCartDrawer');
  this.overlay = document.querySelector('#CustomCartDrawerOverlay');
  this.backdropCursor = document.querySelector('#CustomCartBackdropCursor');
  this.sectionId = window.CustomCartDrawerConfig?.sectionId || 'custom-cart-drawer';

  this.moveDrawerToBody();

  this.bindEvents();
  this.bindBackdropCursor();
  this.loadRecommendations();
}

moveDrawerToBody() {
  let portal = document.querySelector('#CustomCartPortal');

  if (!portal) {
    portal = document.createElement('div');
    portal.id = 'CustomCartPortal';
    document.body.appendChild(portal);
  }

  if (this.overlay && this.overlay.parentElement !== portal) {
    portal.appendChild(this.overlay);
  }

  if (this.backdropCursor && this.backdropCursor.parentElement !== portal) {
    portal.appendChild(this.backdropCursor);
  }

  if (this.drawer && this.drawer.parentElement !== portal) {
    portal.appendChild(this.drawer);
  }
}

  bindEvents() {
    document.addEventListener('click', async (event) => {
      const openTrigger = event.target.closest('[data-cart-open]');
      const closeTrigger = event.target.closest('[data-cart-close]');
      const overlayTrigger = event.target.closest('#CustomCartDrawerOverlay');
      const qtyPlus = event.target.closest('[data-cart-qty-plus]');
      const qtyMinus = event.target.closest('[data-cart-qty-minus]');
      const removeButton = event.target.closest('[data-cart-remove]');
      const addRecommendation = event.target.closest('[data-recommendation-add]');
      const discountToggle = event.target.closest('[data-discount-toggle]');
      const discountApply = event.target.closest('[data-discount-apply]');

      if (openTrigger) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  await this.refreshDrawer();
  this.open();
  return;
}

      if (closeTrigger || overlayTrigger) {
        event.preventDefault();
        this.close();
        return;
      }

      if (qtyPlus) {
        event.preventDefault();
        const key = qtyPlus.dataset.key;
        const currentQty = Number(qtyPlus.dataset.quantity);
        this.changeItemQuantity(key, currentQty + 1);
        return;
      }

      if (qtyMinus) {
        event.preventDefault();
        const key = qtyMinus.dataset.key;
        const currentQty = Number(qtyMinus.dataset.quantity);
        const newQty = currentQty - 1;

        this.changeItemQuantity(key, newQty <= 0 ? 0 : newQty);
        return;
      }

      if (removeButton) {
        event.preventDefault();
        const key = removeButton.dataset.key;
        this.changeItemQuantity(key, 0);
        return;
      }

      if (addRecommendation) {
        event.preventDefault();
        const variantId = addRecommendation.dataset.variantId;
        this.addItem(variantId, 1);
        return;
      }

      if (discountToggle) {
        event.preventDefault();
        this.toggleDiscountForm(discountToggle);
        return;
      }

      if (discountApply) {
  event.preventDefault();
  await this.applyDiscount(discountApply);
  return;
}
    },true);

    document.addEventListener('submit', async (event) => {
  const productForm = event.target.closest('form[action*="/cart/add"]');

  if (!productForm) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  await this.addFromProductForm(productForm);
}, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  bindBackdropCursor() {
    if (!this.overlay || !this.backdropCursor) return;

    this.overlay.addEventListener('mousemove', (event) => {
      if (!this.overlay.classList.contains('is-active')) return;

      this.backdropCursor.style.left = `${event.clientX}px`;
      this.backdropCursor.style.top = `${event.clientY}px`;
      this.backdropCursor.classList.add('is-visible');
    });

    this.overlay.addEventListener('mouseenter', () => {
      if (!this.overlay.classList.contains('is-active')) return;

      this.backdropCursor.classList.add('is-visible');
    });

    this.overlay.addEventListener('mouseleave', () => {
      this.backdropCursor.classList.remove('is-visible');
    });
  }

open() {
  if (!this.drawer || !this.overlay) return;

  this.moveDrawerToBody();

  requestAnimationFrame(() => {
    const portal = document.querySelector('#CustomCartPortal');

    if (portal) {
      portal.style.pointerEvents = 'auto';
    }

    this.drawer.classList.add('is-active');
    this.overlay.classList.add('is-active');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('custom-cart-open');
    document.body.classList.add('custom-cart-open');
  });
}

close() {
  if (!this.drawer || !this.overlay) return;

  this.drawer.classList.remove('is-active');
  this.overlay.classList.remove('is-active');
  this.drawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('custom-cart-open');
  document.body.classList.remove('custom-cart-open');

  const portal = document.querySelector('#CustomCartPortal');

  if (portal) {
    portal.style.pointerEvents = 'none';
  }

  if (this.backdropCursor) {
    this.backdropCursor.classList.remove('is-visible');
  }
}

  getRecommendationRating(productId) {
  const seed = Number(productId) % 3;

  let ratingRaw;

  if (seed === 0) {
    ratingRaw = 4.4;
  } else if (seed === 1) {
    ratingRaw = 4.5;
  } else {
    ratingRaw = 4.6;
  }

  const ratingCount = (Number(productId) % 101) + 100;
  const roundedRating = ratingRaw >= 4.5 ? 5 : 4;

  let stars = '';

  for (let i = 1; i <= 5; i++) {
    stars += `<span class="star ${i <= roundedRating ? 'is-filled' : ''}">★</span>`;
  }

  return `
    <div class="cart-recommendation-card__rating">
      <div class="cart-recommendation-card__stars" aria-label="Rated ${ratingRaw} out of 5">
        <div style="display:flex">
          ${stars}
        </div>
      </div>

      <div class="cart-recommendation-card__rating-text">
        ${ratingRaw} (${ratingCount})
      </div>
    </div>
  `;
}

  async addFromProductForm(form) {
    const formData = new FormData(form);

    try {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });

      await this.refreshDrawer();
      this.open();
    } catch (error) {
      console.error('Cart add error:', error);
    }
  }

  async addItem(variantId, quantity = 1) {
    if (!variantId) return;

    try {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity)
        })
      });

      await this.refreshDrawer();
      this.open();
    } catch (error) {
      console.error('Recommendation add error:', error);
    }
  }

  async changeItemQuantity(key, quantity) {
    if (!key && key !== 0) return;

    try {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: Number(quantity)
        })
      });

      await this.refreshDrawer();
      this.open();
    } catch (error) {
      console.error('Cart quantity error:', error);
    }
  }

  toggleDiscountForm(button) {
    const form = document.querySelector('[data-discount-form]');
    const caret = button || document.querySelector('[data-discount-toggle]');

    if (!form) return;

    const isOpening = form.hidden;

    form.hidden = !isOpening;

    if (caret) {
      caret.classList.toggle('is-open', isOpening);
      caret.setAttribute('aria-expanded', String(isOpening));
      caret.setAttribute('aria-label', isOpening ? 'Close discount field' : 'Open discount field');
    }

    if (isOpening) {
      const input = document.querySelector('[data-discount-input]');
      setTimeout(() => {
        if (input) input.focus();
      }, 100);
    }
  }

    async applyDiscount(button) {
  if (this.isApplyingDiscount) return;

  const input = document.querySelector('[data-discount-input]');
  const message = document.querySelector('[data-discount-message]');

  if (!input) return;

  const code = input.value.trim();

  if (!code) {
    if (message) {
      message.textContent = 'Please enter a discount code.';
      message.classList.remove('is-success');
      message.classList.add('is-error');
    }

    return;
  }

  this.isApplyingDiscount = true;
  this.setDiscountLoading(button, input, true);

  if (message) {
    message.textContent = '';
    message.classList.remove('is-success', 'is-error');
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: code
      })
    });

    if (!response.ok) {
      throw new Error('Discount request failed.');
    }

    await response.json();

    const freshCart = await this.getFreshCartAfterDiscount(code);
    const appliedCode = this.isDiscountCodeApplied(freshCart, code);

    if (!appliedCode) {
      if (message) {
        message.textContent = 'Invalid or ineligible discount code.';
        message.classList.remove('is-success');
        message.classList.add('is-error');
      }

      return;
    }

    await this.refreshDrawer();
    this.open();

    const refreshedForm = document.querySelector('[data-discount-form]');
    const refreshedInput = document.querySelector('[data-discount-input]');
    const refreshedMessage = document.querySelector('[data-discount-message]');
    const refreshedToggle = document.querySelector('[data-discount-toggle]');

    if (refreshedForm) {
      refreshedForm.hidden = false;
    }

    if (refreshedInput) {
      refreshedInput.value = code;
    }

    if (refreshedToggle) {
      refreshedToggle.classList.add('is-open');
      refreshedToggle.setAttribute('aria-expanded', 'true');
      refreshedToggle.setAttribute('aria-label', 'Close discount field');
    }

    if (refreshedMessage) {
      refreshedMessage.textContent = 'Discount applied successfully.';
      refreshedMessage.classList.remove('is-error');
      refreshedMessage.classList.add('is-success');
    }

  } catch (error) {
    console.error('Discount error:', error);

    if (message) {
      message.textContent = 'This discount could not be applied.';
      message.classList.remove('is-success');
      message.classList.add('is-error');
    }
  } finally {
    this.isApplyingDiscount = false;
    this.setDiscountLoading(button, input, false);
  }
}

    isDiscountCodeApplied(cart, code) {
  const normalizedCode = String(code).trim().toLowerCase();

  // Check cart-level discount applications
  const cartLevelDiscounts = cart.cart_level_discount_applications || [];

  const cartLevelMatch = cartLevelDiscounts.some((discount) => {
    const title = String(discount.title || '').trim().toLowerCase();
    return title === normalizedCode || title.includes(normalizedCode);
  });

  if (cartLevelMatch) return true;

  // Check line-level discount allocations
  const items = cart.items || [];

  const lineLevelMatch = items.some((item) => {
    const allocations = item.line_level_discount_allocations || [];

    return allocations.some((allocation) => {
      const title = String(
        allocation.discount_application?.title || allocation.title || ''
      ).trim().toLowerCase();

      return title === normalizedCode || title.includes(normalizedCode);
    });
  });

  if (lineLevelMatch) return true;

  // Fallback: some Shopify setups return discount_applications
  const discountApplications = cart.discount_applications || [];

  const discountApplicationMatch = discountApplications.some((discount) => {
    const title = String(discount.title || discount.code || '').trim().toLowerCase();
    return title === normalizedCode || title.includes(normalizedCode);
  });

  return discountApplicationMatch;
}

setDiscountLoading(button, input, isLoading) {
  if (button) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);

    if (isLoading) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Applying...';
    } else {
      button.textContent = button.dataset.originalText || 'Apply';
      delete button.dataset.originalText;
    }
  }

  if (input) {
    input.disabled = isLoading;
  }
}

delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async getFreshCartAfterDiscount(code) {
  let freshCart = null;

  const waitTimes = [250, 500, 900, 1300];

  for (const waitTime of waitTimes) {
    await this.delay(waitTime);

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: {
        'Cache-Control': 'no-cache'
      }
    });

    if (!cartResponse.ok) continue;

    freshCart = await cartResponse.json();

    if (this.isDiscountCodeApplied(freshCart, code)) {
      return freshCart;
    }
  }

  return freshCart || {};
}

async refreshDrawer() {
  try {
    const response = await fetch(`${window.location.pathname}?sections=${this.sectionId}`);
    const sections = await response.json();
    const html = sections[this.sectionId];

    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('#CustomCartDrawer');

    if (newDrawer && this.drawer) {
      this.drawer.innerHTML = newDrawer.innerHTML;
    }

    this.moveDrawerToBody();
    this.loadRecommendations();
    this.updateCartBubble();

  } catch (error) {
    console.error('Drawer refresh error:', error);
  }
}

  async updateCartBubble() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();

      const cartCountEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count');

      cartCountEls.forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Cart bubble update error:', error);
    }
  }

async loadRecommendations() {
  const container = document.querySelector('[data-cart-recommendations]');

  if (!container) return;

  const contextScript = document.querySelector('[data-cart-recommendation-context]');

  if (!contextScript) {
    container.innerHTML = '';
    return;
  }

  let cartContext = [];

  try {
    cartContext = JSON.parse(contextScript.textContent || '[]');
  } catch (error) {
    console.error('Cart recommendation context error:', error);
    container.innerHTML = '';
    return;
  }

  if (!cartContext.length) {
    container.innerHTML = '';
    return;
  }

  const DOG_COLLECTION_HANDLE = 'for-dogs';
  const CAT_COLLECTION_HANDLE = 'for-cats';

  const IGNORED_COMMON_COLLECTIONS = [
    DOG_COLLECTION_HANDLE,
    CAT_COLLECTION_HANDLE,
    'all',
    'frontpage',
    'home-page',
    'best-sellers'
  ];

  const cartProductIds = new Set(
    cartContext.map((item) => String(item.productId))
  );

  const cartHasDogs = cartContext.some((item) =>
    (item.collections || []).includes(DOG_COLLECTION_HANDLE)
  );

  const cartHasCats = cartContext.some((item) =>
    (item.collections || []).includes(CAT_COLLECTION_HANDLE)
  );

  if (!cartHasDogs && !cartHasCats) {
    container.innerHTML = '';
    return;
  }

  const collectionLists = cartContext.map((item) =>
    (item.collections || []).filter((handle) => !IGNORED_COMMON_COLLECTIONS.includes(handle))
  );

  let commonCollectionHandles = [];

  if (collectionLists.length > 1) {
    commonCollectionHandles = collectionLists[0].filter((handle) =>
      collectionLists.every((list) => list.includes(handle))
    );
  } else {
    commonCollectionHandles = collectionLists[0] || [];
  }

  const fallbackCollectionHandles = [];

  if (cartHasDogs) fallbackCollectionHandles.push(DOG_COLLECTION_HANDLE);
  if (cartHasCats) fallbackCollectionHandles.push(CAT_COLLECTION_HANDLE);

  try {
    const finalProducts = [];
    const seenProductIds = new Set();

    const addProduct = (product) => {
      if (!product) return;

      const productId = String(product.id);

      if (cartProductIds.has(productId)) return;
      if (seenProductIds.has(productId)) return;

      const variant = this.getFirstAvailableVariant(product);

      if (!variant) return;

      seenProductIds.add(productId);
      finalProducts.push(product);
    };

    // Priority 1: common collections between cart products
    if (commonCollectionHandles.length) {
      const commonProductsByCollection = await Promise.all(
        commonCollectionHandles.map((handle) => this.fetchCollectionProducts(handle))
      );

      const commonProducts = this.interleaveProducts(commonProductsByCollection);

      commonProducts.forEach(addProduct);
    }

    // Priority 2: if common collection is empty / not enough, fallback to dog + cat collections
    if (finalProducts.length < 8) {
      const fallbackProductsByCollection = await Promise.all(
        fallbackCollectionHandles.map((handle) => this.fetchCollectionProducts(handle))
      );

      const fallbackProducts = this.interleaveProducts(fallbackProductsByCollection);

      fallbackProducts.forEach(addProduct);
    }

    const cards = finalProducts
      .slice(0, 8)
      .map((product) => this.renderRecommendationCard(product))
      .filter(Boolean);

    if (!cards.length) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = cards.join('');
  } catch (error) {
    console.error('Recommendations error:', error);
    container.innerHTML = '';
  }
}

async fetchCollectionProducts(collectionHandle) {
  try {
    const url = `${window.Shopify.routes.root}collections/${collectionHandle}/products.json?limit=250`;
    const response = await fetch(url);

    if (!response.ok) return [];

    const data = await response.json();

    return data.products || [];
  } catch (error) {
    console.error(`Collection fetch error for ${collectionHandle}:`, error);
    return [];
  }
}

interleaveProducts(productLists) {
  const result = [];
  const maxLength = Math.max(...productLists.map((list) => list.length), 0);

  for (let i = 0; i < maxLength; i++) {
    productLists.forEach((list) => {
      if (list[i]) {
        result.push(list[i]);
      }
    });
  }

  return result;
}

getFirstAvailableVariant(product) {
  if (!product || product.available === false) return null;

  const variants = product.variants || [];

  return variants.find((variant) => variant.available === true) || null;
}

getProductImage(product) {
  if (product.featured_image) return product.featured_image;

  if (product.image && product.image.src) {
    return product.image.src;
  }

  if (product.images && product.images.length) {
    if (typeof product.images[0] === 'string') {
      return product.images[0];
    }

    return product.images[0].src || '';
  }

  return '';
}

normalizeMoneyToCents(value) {
  if (value === null || value === undefined || value === '') return 0;

  if (typeof value === 'number') {
    return value;
  }

  const cleanedValue = String(value).replace(/[^0-9.]/g, '');

  if (!cleanedValue) return 0;

  if (cleanedValue.includes('.')) {
    return Math.round(Number(cleanedValue) * 100);
  }

  return Number(cleanedValue);
}

renderRecommendationCard(product) {
  const variant = this.getFirstAvailableVariant(product);

  if (!variant) return '';

  const image = this.getProductImage(product);
  const priceCents = this.normalizeMoneyToCents(variant.price);
  const compareAtPriceCents = this.normalizeMoneyToCents(variant.compare_at_price);

  const price = this.formatMoney(priceCents);
  const compareAtPrice = compareAtPriceCents ? this.formatMoney(compareAtPriceCents) : '';

  const hasDiscount = compareAtPriceCents && compareAtPriceCents > priceCents;

  let discountPercent = '';

  if (hasDiscount) {
    discountPercent = Math.round(
      ((compareAtPriceCents - priceCents) / compareAtPriceCents) * 100
    );
  }

  const variantTitle = variant.title && variant.title !== 'Default Title'
    ? ` | ${variant.title}`
    : '';

  const finalTitle = `${product.title}${variantTitle}`;
  const productUrl = product.url || `${window.Shopify.routes.root}products/${product.handle}`;

  return `
    <div class="cart-recommendation-card">
      <a href="${productUrl}" class="cart-recommendation-card__image">
        ${image ? `<img src="${image}" alt="${this.escapeHtml(finalTitle)}" loading="lazy">` : ''}
      </a>

      <div class="cart-recommendation-card-content-div">
        <div class="content">
          <h4 class="cart-recommendation-card__title">
            ${this.escapeHtml(finalTitle)}
          </h4>

          <div class="cart-recommendation-card__meta">
            ${this.getRecommendationRating(product.id)}
          </div>

          <div class="cart-recommendation-card__price">
            <strong>${price}</strong>
          </div>

          <div class="cart-recommendation-card__price">
            ${compareAtPrice ? `MRP <s>${compareAtPrice}</s>` : ''}
            ${discountPercent ? `<span class="cart-recommendation-card__off">${discountPercent}% off</span>` : ''}
          </div>
        </div>

        <button
          type="button"
          class="cart-recommendation-card__button"
          data-recommendation-add
          data-variant-id="${variant.id}"
        >
          Add to cart
        </button>
      </div>
    </div>
  `;
}

  formatMoney(amount) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount / 100);
  }

  escapeHtml(string) {
    return String(string)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.customCartDrawer = new CustomCartDrawer();
});

